export default "__VITE_ASSET__CBZxZrpT__"